// extracted by mini-css-extract-plugin
export default {"container":"styles_container__LQDxh","icone":"styles_icone__2swDe","indicador":"styles_indicador__R-hgh"};